'use client'

import { useTranslations } from 'next-intl'
import AppLink from '@/components/elementary/AppLink'
import { Paragraph } from '@/components/typography/Paragraph'
import { cn } from '@/lib/styles'
import type { GridCategoryNavigationData } from '@/types/general'

export function SidePanelCategoryNavigation({
	topCategories,
	restCategories,
	additionalLink,
	categorySlug,
}: GridCategoryNavigationData & { categorySlug?: string | null }) {
	const t = useTranslations('categoryFilter')

	const isActive = (slug?: string | null) => {
		if (categorySlug === null && slug === null) return true // Both null = "All" page
		return slug === categorySlug
	}
	return (
		<div className="lg:flex hidden flex-col gap-8 w-full lg:max-w-74.5">
			{Array.isArray(topCategories) && topCategories?.length > 0 ? (
				<nav>
					<ul className="flex flex-col gap-3">
						{topCategories?.map((category) => {
							return (
								<li key={category.documentId}>
									<AppLink
										size="none"
										variant="ghost"
										href={category.link}
										scroll={false}
										className={cn(
											'flex justify-start',
											isActive(category.slug) && 'text-brand-salmon font-bold',
										)}
									>
										{category?.title}
									</AppLink>
								</li>
							)
						})}
					</ul>
				</nav>
			) : null}

			<div className="flex flex-col gap-4">
				<Paragraph fontSize="headingSmall">{t('categories')}</Paragraph>
				<nav>
					<ul className="flex flex-col gap-3">
						{restCategories?.map((category) => {
							return (
								<li key={category.documentId}>
									<AppLink
										size="none"
										variant="ghost"
										href={category.link}
										scroll={false}
										className={cn(
											'flex justify-start',
											isActive(category.slug) && 'text-brand-salmon font-bold',
										)}
									>
										{category?.title}
									</AppLink>
								</li>
							)
						})}
					</ul>
				</nav>
			</div>

			{additionalLink?.href && (
				<div className="border-t border-neutral-light-40 pt-9">
					<AppLink
						href={additionalLink.href}
						openExternalInNewTab={additionalLink.newTab ?? false}
						size="none"
						variant="ghost"
					>
						{additionalLink.label}
					</AppLink>
				</div>
			)}
		</div>
	)
}
